/**
 * The result is the same date (day, month, year) but ignores the time (hours, minutes, seconds etc.).
 * @param date The date to be normalized.
 */
export function normalizeDate(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
